import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DepositEntityService } from '../../services/deposit-entity.service';
import { Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'kt-deposit-approve',
  // The dialog itself is a Swal popup; the Material dialog shell has no content of its own.
  template: ''
})
export class DepositApproveComponent implements OnInit {
  loading = false;
  messages$ = new Subject<string[]>();

  constructor(
    private depositEntityService: DepositEntityService,
    public dialogRef: MatDialogRef<DepositApproveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.showApprovalDialog();
  }

  showApprovalDialog(): void {
    const swalTitle = 'Manual Approve Deposit Transaction';
    const swalText = '<p style="color: #999; margin-bottom: 10px;">No callback was received from the payment vendor for this deposit.</p>' +
                    '<p style="margin-bottom: 10px;"><span style="color: #999;">Only approve if you have </span><strong>confirmed with the vendor</strong><span style="color: #999;"> that the deposit succeeded.</span></p>' +
                    '<p style="margin-bottom: 5px;"><strong>This action cannot be reverted.</strong> Are you sure you want to proceed with this transaction?</p>';

    const remarksHtml = `<p style="color: red;">Remark</p><input id="remark-input" class="form-control">`;

    Swal.fire({
      title: swalTitle,
      html: '<div style="text-align: center;">' + remarksHtml + '<p style="margin-top: 20px;">' + swalText + '</p></div>',
      icon: 'info',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      preConfirm: () => {
        const inputValue = ((document.getElementById('remark-input') as HTMLInputElement)?.value ?? '').trim();

        // Same rule as the payout manual-resolve dialog: the remark is the operator's audited reason.
        if (inputValue === '') {
          Swal.showValidationMessage('Remark is required');
          return false;
        }

        return inputValue;
      }
    }).then((resp) => {
      if (resp.value !== undefined && resp.value !== null) {
        this.loading = true;
        const payload = {
          status: 1, // 1 = approve
          remarks: resp.value || ''
        };

        // Match withdrawal pattern: use messages$ stream that parent component (deposit-wrapper) listens to
        this.depositEntityService.updateNew(this.data.deposit.id, payload).pipe(
          tap((response: any) => {
            // Bridge success message to messages$ stream (parent component will show via kt-swal-alert, matching BO design)
            this.messages$.next(Array.isArray(response?.message) ? response.message : [response?.message || 'Deposit approved successfully']);
            this.loading = false;
            this.dialogRef.close(true);
          }),
          catchError((error: any) => {
            this.loading = false;
            const errorMessage = error.error?.message?.[0] || 'An error occurred while processing the deposit';
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              confirmButtonText: 'OK'
            });
            // Nothing is left to show in the Material shell once the Swal closes.
            this.dialogRef.close(false);
            return throwError(() => error);
          })
        ).subscribe();
      } else {
        this.dialogRef.close(false);
      }
    });
  }
}
